export enum RouteNames {
    ACCOUNT_SETTINGS='/account-settings',
    CORG_REQUEST='/certificate-of-registration',
    DASHBOARD='/dashboard',
    EMAIL_VERIFIED='/email-verified',
    EMPLOYER='/employer',
    FAQS='/faqs',
    FEEDBACK='/feedback',
    FORGOT_PASSWORD='/forgot-password',
    FUND_TRANSFER='/fund-transfer',
    HOME='/',
    INITIATE_BENEFIT='/initiate-benefit',
    LOGIN='/login',
    MISSING_MONTHS='/missing-months',
    SELF_CONTRIBUTION='/self-contribution',
    MY_MEMORABLE_DAYS='/my-memorable-days',
    MY_REFERRALS='/my-referrals',
    NEXT_OF_KIN='/next-of-kin',
    BENEFICIARIES='/beneficiaries-list',
    ONBOARDING='/onboarding',
    PENSION_CALCULATOR='pension-calculator',
    PRIVACY='/privacy-policy',
    REGISTER_A_FRIEND='/register-rsa',
    REQUEST_STATEMENT='/request-statement',
    REQUEST_STATEMENT_THIRD_PARTY='/request-statement-third-party',
    RESET_PASSWORD='/reset-password',
    SIGNUP='/signup',
    SUPPORT='/support',
    TRACK_BENEFIT='/track-benefit',
    TRANSACTIONS='/transactions',
    TRANSFER_RSA='/transfer-rsa',
    VIRTUAL_NIN='/virtual-nin',
    WHISTLE_BLOWING='/whistle-blowing',
}

export enum CustomerType {
    TPIN='TPIN',
    RSA='RSA',
}

export enum SettingTab {
    ACCOUNT_MANAGER="ACCOUNT_MANAGER",
    KYC="KYC",
    PASSCODE_MANAGEMENT="PASSCODE_MANAGEMENT",
    CHANGE_PASSWORD="CHANGE_PASSWORD",
    SUBSCRIPTIONS="SUBSCRIPTIONS",
    RECPATURE="RECPATURE",
}


export const BenefitApplicationType = [
    {
        title: "25% of RSA Balance",
        value: 0,
    },
    {
        title: "Enbloc Withdrawal",
        value: 1,
    },
    {
        title: "Legacy Withdrawal",
        value: 2,
    },
    {
        title: "NSITF Withdrawal",
        value: 3,
    },
    {
        title: "Lump Sum & Programmed Withdrawal",
        value: 4,
    },
    // {
    //     title: "ProgrammedWithdrawal",
    //     value: 5
    // },
    {
        title: "Voluntary Contributions",
        value: 5,
    },
    
    {
        title: "Annuity",
        value: 6,
    },
    {
        title: "Equity Withdrawal",
        value: 7,
    }
];

export const BenefitLumpSumType = [
    {
        title: "Private",
        value: 1,
    },
    {
        title: "Public/State",
        value: 2,
    },
]

export const BenefitModeOfExit = [
    {
        title: "Mandatory",
        value: 0,
    },
    {
        title: "Health",
        value: 1,
    },
    {
        title: "TermsAndConditions",
        value: 2
    },
    {
        title: "Voluntary",
        value: 3
    },
]

export const FundType =  [
    'FUND I',
    'FUND II',
    'FUND III',
    'FUND IV',
    'FUND V (MPP)',
    'FUND VI ACTIVE',
    'FUND VI RETIREE'
];

export const RSATransferType = [
    {
        value: 12,
        label: "RSA Transfers",
    },
    {
        value: 19,
        label: "Retiree Transfers",
    },
    {
        value: 19,
        label: "Micro Pension Transfers",
    },
    {
        value: 26,
        label: "Non Interest Transfer",
    },
];


export const WhistleBlowingModeOfEngagement = [
    "Phone Number",
    "Email",
    "In Person",
    "Reported By Third Party"
]